export default "__VITE_ASSET__BZg$VrHl__"